import React, { useState } from 'react';
import MetaTags from 'react-meta-tags';
import { useHistory, Link } from 'react-router-dom';
import { apiEndpoint } from 'helpers/url_helper';
import { Row, Col, CardBody, Card, Alert, Container } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
// import logoDark from '../../assets/images/Logo.png';
import logoDark from 'assets/images/Logo.png';

const DefaultPasswordChangeComponent = () => {
  const [error, setErrors] = useState('');
  const [errorColor, setErrorColor] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  let history = useHistory();

  // Validation rules
  const validate = () => {
    const newErrors = {};

    // Required field validation
    if (!password) {
      newErrors.password = 'Please enter password';
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password';
    }

    // Pattern validation
    const passwordPattern = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
    if (password && !passwordPattern.test(password)) {
      newErrors.password = 'Password must contain 7-15 characters with at least one digit and one special character';
    }

    // Length validation
    if (password && (password.length < 7 || password.length > 15)) {
      newErrors.password = 'Password must be between 7 and 15 characters';
    }

    // Password match validation
    if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    return newErrors;
  };

  // Handle Change Password
  const handleChangePassword = () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      // Implement password change logic here

      fetch(apiEndpoint + '/ChangeDefaultPassword', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "Token": sessionStorage.getItem("Clear_AuthUser"),
          Password: password,
        }),
      })
        .then((res) => res.json())
        .then(
          (response) => {
            console.log("Default change response", response);
            if (response.status) {
              
              setErrors(response.message);
              setErrorColor('success');

              sessionStorage.removeItem("userFullName")
              sessionStorage.removeItem("Clear_AuthUser")
              sessionStorage.removeItem("GetToChange")
              history.push('/');
            } else {
              setErrors(response.message);
              setErrorColor('danger');
            }
          },
          (error) => {
            setErrors('An unexpected error occurred.');
            setErrorColor('danger');
          }
        );
    } else {
      setErrors(validationErrors);
      setErrorColor('danger');
    }
  };

  // Handle Logout
  const handleLogout = () => {
    // Implement logout logic here
    const response = fetch(apiEndpoint+'/Logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', 
      },
        body: JSON.stringify({
          "Token": sessionStorage.getItem("Clear_AuthUser")
      })
    });
    sessionStorage.removeItem("userFullName")
    sessionStorage.removeItem("Clear_AuthUser")
    sessionStorage.removeItem("GetToChange")
    history.push('/');
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Indus - Change Password</title>
      </MetaTags>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link className="d-block auth-logo">
                      <img src={logoDark} alt="" height="60" className="auth-logo-dark" />
                    </Link>
                  </h3>
                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">Welcome to the Indus Application!</h4>
                    <p className="text-muted text-center">For your security, please update your password now.</p>
                    <AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={handleChangePassword}
                    >
                      {error && typeof error === 'string' ? (
                        <Alert color={errorColor}>{error}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <label for="Password" className="mt-3">Password *</label>
                        <AvField
                          name="Password"
                          placeholder="Enter password here"
                          type="password"
                          className="form-control"
                          id="Password"
                          onChange={(event) => setPassword(event.target.value)}
                          validate={{
                          required: {value: true, errorMessage: 'Please enter password'},
                          pattern: {value: '^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$', errorMessage: 'Password must contain 7-15 characters with atleast one digit & a special character'},
                          minLength: {value: 7, errorMessage: 'Password must be between 7 and 15 characters'},
                          maxLength: {value: 15, errorMessage: 'Password must be between 7 and 15 characters'}
                          }}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label for="ConfirmPassword" className="mt-3">Confirm Password *</label>
                        <AvField
                          name="ConfirmPassword"
                          placeholder="Enter password here"
                          type="password"
                          className="form-control"
                          id="ConfirmPassword"
                          onChange={(event) => setConfirmPassword(event.target.value)}
                          validate={{
                          required: {value: true, errorMessage: 'Please enter password'},
                          pattern: {value: '^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$', errorMessage: 'Password must contain 7-15 characters with atleast one digit & a special character'},
                          minLength: {value: 7, errorMessage: 'Password must be between 7 and 15 characters'},
                          maxLength: {value: 15, errorMessage: 'Password must be between 7 and 15 characters'},
                          match: {value: 'Password', errorMessage: 'Password does not match'}
                          }}
                          required
                        />
                      </div>

                      <div className="mb-3 row mt-4">
                        <div className="col-6">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            // onClick={handleChangePassword}
                            type="submit"
                          >
                            Change Password
                          </button>
                        </div>
                        <div className="col-6 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            onClick={handleLogout}
                          >
                            Logout
                          </button>
                        </div>
                      </div>
                    </AvForm>
                    <p style={{ marginTop: '20px', color: 'red', textAlign:'center' }}>
                      After successfully changing the password, you'll be logged out and will require to log in using your new password.
                    </p>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} <span className="d-none d-sm-inline-block">Ador Powertron Ltd </span>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
    // <div>
    //   <div>
    //     <label>
    //       Enter Password:
    //       <input
    //         type="password"
    //         value={password}
    //         onChange={(e) => setPassword(e.target.value)}
    //       />
    //       {errors.password && <span>{errors.password}</span>}
    //     </label>
    //   </div>
    //   <div>
    //     <label>
    //       Confirm Password:
    //       <input
    //         type="password"
    //         value={confirmPassword}
    //         onChange={(e) => setConfirmPassword(e.target.value)}
    //       />
    //       {errors.confirmPassword && <span>{errors.confirmPassword}</span>}
    //     </label>
    //   </div>
    //   <div>
    //     <button onClick={handleChangePassword}>Change Password</button>
    //     <button onClick={handleLogout}>Logout</button>
    //   </div>
    // </div>
  );
};

export default DefaultPasswordChangeComponent;
